module.exports = __webpack_public_path__ + "static/img/ETEK-JC-IG2.b1c908d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/ETEK-JC-IG2.png
// module id = fso6
// module chunks = 1